import { render, staticRenderFns } from "./workDia.vue?vue&type=template&id=50da0281&scoped=true&"
import script from "./workDia.vue?vue&type=script&lang=js&"
export * from "./workDia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da0281",
  null
  
)

export default component.exports